<template>
  <div class="dialog">
    <el-dialog :title="title"
               :visible.sync="visible"
               :lock-scroll="true"
               width="1000px"
               :before-close="handleClose">
      <el-form ref="formTool"
               :model="formTool"
               :inline="true"
               style="text-align: left"
               label-width="140px">
        <div class="goodList">
          <div class="img-div">
            <el-image class="l"
                      :src="formTool.image ? formTool.image : avater"
                      alt="" />
          </div>
          <div class="r">
            <div>
              <span class="txt-line-1 name">{{ formTool.name }}</span>
            </div>
            <div>
              <span class="rr txt-line-1">{{ formTool.factory }}</span>
            </div>
            <div>
              <span class="rr txt-line-1">{{ formTool.specification }}</span>
            </div>
            <!-- <div>
                            <span class="rr txt-line-1">{{ formTool.approvalNumber }}</span>
                        </div> -->
          </div>
        </div>

        <div class="left_topic mb20"
             style="margin-top: 10px">选择批号</div>
        <el-row class="list">
          <el-checkbox-group v-model="formTool.checkList"
                             @change="change">
            <el-checkbox :label="item"
                         v-for="(item, key) in checkListOptons"
                         :key="key">{{ item }}</el-checkbox>
          </el-checkbox-group>

        </el-row>
      </el-form>
      <div class="btnBox"
           v-if="!isDisabled">
        <el-button size="small"
                   @click="handleClose">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="chooseGoods"
                   :disabled="this.pageType =='detail'">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import avater from "/public/img/default.png";
// import { addDeptGoods ,updateDeptGoods} from "@/api/externalSalesRule";
import { getBatchNumbers, messageRecallAdd, messageRecallQueryDetail } from "@/api/product";
export default {
  components: {

  },
  props: {
    btnType: {
      type: String,
      default: ''
    },
  },
  computed: {
    visible () {
      return this.dialogShow
    }
  },
  data () {
    return {

      checkListOptons: [],
      avater: avater,
      showForm: false, //是否展示表单
      dialogShow: false,
      isDisabled: false,
      pageType: '',
      info: {},
      formTool: {
        checkList: []
      },
      title: '',
      goodsList: [],
      selectItems: [],
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
    }
  },
  mounted () {
  },
  methods: {
    init (row, type) {
      this.pageType = type;
      const newRow = Object.assign(this.formTool, row);
      this.formTool = newRow;
      this.title = '';
      if (type == 'add') {
        this.isDisabled = false;
        this.title = '新增召回商品';
        this.formTool.checkList = [];
        this.getBatchNumbers();
      }
      if (type == 'detail') {
        this.title = '查看召回商品';
        this.query(row.id);
      }
      this.dialogShow = true;
      this.$forceUpdate();
    },

    change (e) {
      this.$forceUpdate()
      console.log(this.formTool.checkList)
    },

    query (id) {
      messageRecallQueryDetail({ id: id }).then((res) => {
        if (res) {
          this.formTool = res;
          this.formTool.name = res.goodsName;
          this.formTool.checkList = res.batchNumberList;
          this.checkListOptons = res.batchNumberList;
        }
      });
    },

    getBatchNumbers () {
      getBatchNumbers({ goodsId: this.formTool.goodsId }).then((res) => {
        this.checkListOptons = [];
        this.checkListOptons = res;
      });
    },

    handleClose () {
      this.dialogShow = false;
    },

    cancel () {
      this.dialogShow = false;
    },
    chooseGoods () {
      let params = {};
      console.log(this.formTool.checkList)
      params.goodsId = this.formTool.goodsId;
      params.goodsName = this.formTool.name;
      params.factory = this.formTool.factory;
      params.specification = this.formTool.specification;
      params.batchNumberListQo = this.formTool.checkList;
      params.image = this.formTool.image;
      if (!this.formTool.checkList) {
        this.$message.error('请选择批号！')
        return
      }
      messageRecallAdd(params).then((res) => {
        if (res) {
          this.$message.success('提交成功')
          this.$emit('getList')
          this.handleClose();
        }
      });

    }
  }
}
</script>
<style lang="scss">
.btnBox {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.serach {
  margin-bottom: 10px;
}

.goods-content {
  max-height: 70vh;
  overflow-y: auto;
}

.goodList {
  display: flex;
  justify-content: space-around;

  &:nth-child(3n) {
    margin-right: 0px;
  }

  .img-div {
    height: 88px;
    width: 88px;
    margin: 0 10px;

    image {
      width: 100%;
      height: 100%;
    }
  }

  .l {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
  }

  .r {
    width: 214px;
    display: flex;
    flex: 1;
    flex-direction: column;

    div {
      display: flex;
    }

    span {
      font-size: 13px;
      color: #333;
      //margin-top: 10px;
    }

    .name {
      text-align: left;
      font-size: 16px;
      font-weight: 600;
      color: var(--color-26);
    }

    .rr {
      text-align: left;
      color: var(--color-59);
      font-size: 14px;
    }
  }

  &:hover {
    //  border: 2px solid var(--main-color) !important;
  }
}

.reject-c {
  margin-top: 10px;

  .title {
    line-height: 30px;
  }
}

.list {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  line-height: 40px;
}
</style>